



























































































































import * as R from 'ramda';
import Vue from 'vue';

import { User } from '@/core/entity';
import CountryInput from '@/vue/components/input/Country.vue';
import RoleInput from '@/vue/components/input/Role.vue';

import { getUserQL } from './graphql';

export default Vue.extend({
  components: {
    'input-country': CountryInput,
    'input-role': RoleInput,
  },

  props: {
    userId: String as () => string,
    loading: Boolean as () => boolean,
  },

  apollo: {
    user: {
      query: getUserQL,
      variables() {
        return { id: this.userId };
      },
      skip() {
        return !this.userId;
      },
      fetchPolicy: 'cache-first',
    },
  },

  data() {
    return {
      file: [] as File[],
      form: this.$form.createForm(this),
      avatarUrl: '' as string | null,
      user: null as User | null,
    };
  },

  watch: {
    userId(newVal: string | null) {
      this.user = null;
    },

    user(newVal: User) {
      this.form.setFieldsValue({
        name: newVal ? newVal.name : '',
        email: newVal ? newVal.email : '',
        country: newVal ? newVal.country : '',
        roles: newVal ? newVal.roles : [],
      });

      this.avatarUrl = newVal
        ? newVal.avatar
          ? newVal.avatar.url
          : null
        : null;
    },
  },

  methods: {
    beforeUpload(file: File) {
      this.file = [file];
      return false;
    },

    handleSubmit() {
      this.form.validateFields((errors: Error[], val: any) => {
        if (errors === null) {
          const avatar = R.path(['avatar', 'id'], this.user) || null;
          this.$emit('save', {
            name: val.name,
            email: val.email,
            country: val.country,
            roles: val.roles,
            file: this.file.length > 0 ? this.file[0] : avatar,
          });
        }
      });
    },
  },
});
